export const MONITORING_CAPABILITY_OFF = 'off';
export const MONITORING_CAPABILITY_INBOUND = 'inbound';
export const MONITORING_CAPABILITY_OUTBOUND = 'outbound';

/**
 * Mirrors the backend's isMonitoringSupported: monitoring is available when the
 * manifest's declared capability names a direction that invokeDirection offers.
 * Mixed (bi-directional) connectors are supported — only the declared capability
 * direction is monitored on that connector.
 */
export const isConnectorMonitoringSupported = (manifest) => {
  const monitoringCapability = manifest?.monitoringCapability || MONITORING_CAPABILITY_OFF;
  const inbound = manifest?.functionScope?.invokeDirection?.inbound === true;
  const outbound = manifest?.functionScope?.invokeDirection?.outbound === true;

  return (
    (monitoringCapability === MONITORING_CAPABILITY_INBOUND && inbound) ||
    (monitoringCapability === MONITORING_CAPABILITY_OUTBOUND && outbound)
  );
};
